import React from 'react';
import { __ } from '@wordpress/i18n';
import { useNavigate } from 'react-router-dom';

// store
import { useStoreValue } from '../../store';

// components
import ButtonFlat from '../../components/ButtonWrapper/components/ButtonFlat';
import WidgetProjects from './components/WidgetProjects';
import ModalCreateProject from '../../components/ModalCreateProject';
import getNumberWithCurrency from '../../helpers/getNumberWithCurrency';

const Dashboard = () => {
    const navigate = useNavigate();
    const projects = useStoreValue('projects');

    return (
        <>
            <div className="appDashboard">
                <div className="appDashboard__workbench workbenchDashboard">
                    <h1 className="appDashboard__welcomeText">
                        {__('Benvenuto!', 'soundbetween')}<br/>
                        {__('Crea subito il tuo primo progetto', 'soundbetween')}
                    </h1>
                    <ModalCreateProject/>
                    {projects.length > 0
                        ? <ButtonFlat onClick={() => {
                            navigate('/projects');
                        }}>{__('Tutti progetti', 'soundbetween')}</ButtonFlat>
                        : null}
                </div>
            </div>
            <div className="appDashboard__widgets">
                <WidgetProjects/>
                <div className="appDashboard__widget">
                    <div className="appDashboard__widgetTitle">
                        <h2>{__('Guadagni totali', 'soundbetween')}</h2>
                        <span>{getNumberWithCurrency(0)}</span>
                    </div>
                    <p>{__('Qui potrai tenere sotto controllo l’andamento dei tuoi lavori su Soundbetween', 'soundbetween')}</p>
                </div>
                <div className="appDashboard__widget">
                    <div className="appDashboard__widgetTitle">
                        <h2>{__('Contatti', 'soundbetween')}</h2>
                        <div>
                            <span>0</span>
                            <ButtonFlat
                                disabled={true}
                                onClick={() => {
                                }}>
                                {__('Aggiungi contatto', 'soundbetween')}
                            </ButtonFlat>
                        </div>
                    </div>
                    <p>{__('Crea il tuo primo progetto per aggiungere persone al tuo network e creare Team', 'soundbetween')}</p>
                </div>
            </div>
        </>
    )
}

export default Dashboard;